import axios from 'axios';

// Production
export const BaseUrl = "https://ocpbackend.lsc-crm.in/api";
export const BaseImgUrl = "https://ocpbackend.lsc-crm.in";


// Development
// export const BaseUrl = "http://localhost:8000/api";
// export const BaseImgUrl = "http://localhost:8000";


// Cart Related Api
export const addToCart = async (data) => {
  try {
    const response = await axios.post(`${BaseUrl}/addCart`, data);
    return response.data;
  } catch (error) {
    console.error("Error adding to cart:", error);
    throw error;
  }
};

export const getCartDetails = async () => {
  try {
    const response = await fetch(`${BaseUrl}/getCartDetails`, {
      method: "GET",
      credentials: "include", //   ensures cookies (JWT) are sent
    });

    if (!response) {
      throw new Error("Failed to fetch cart details");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching cart details:", error);
    throw error;
  }
};



export const removeCart = async (cartId) => {
  try {
    const response = await axios.get(`${BaseUrl}/removeCart/${cartId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching cart details:", error);
    throw error;
  }
}


//Get Screen Permission
export const screenPermissionDetails = async () => {
  try {
    const response = await axios.get(`${BaseUrl}/authorizedScreen`, {
      withCredentials: true, //   ensures cookies are sent
    });
    return response.data;
  } catch (err) {
    console.error("Profile details:", err);
    throw err;
  }
}


//Profile Related Api

export const profileDetails = async () => {
  try {
    const response = await axios.get(`${BaseUrl}/profile`, {
      withCredentials: true, //   ensures cookies are sent
    });
    return response.data;
  } catch (err) {
    console.error("Profile details:", err);
    throw err;
  }
}


//get Enrolled Course Details
export const getEnrolledCourse = async () => {
  try {
    const response = await axios.get(`${BaseUrl}/my-courses`, {
      withCredentials: true, //   ensures cookies are sent
    });
    return response.data;
  } catch (err) {
    console.error("Profile details:", err);
    throw err;
  }
}

//get Pre Register  Details
export const getPreRegDetails = async (id) => {
  try {
    const response = await axios.get(`${BaseUrl}/pip-form-details`);
    return response.data;
  } catch (err) {
    console.error("Profile details:", err);
    throw err;
  }
}

//get Pre Register  Details
export const addPipDetails = async (data) => {
  try {
    const response = await axios.post(`${BaseUrl}/pip-reg-details`, data, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    return response.data;
  } catch (err) {
    console.error("Profile details error:", err.response?.data || err.message);
    throw err;
  }
};

//get Coordinator Details
export const getCoordDetails = async () => {
  try {
    const response = await axios.get(`${BaseUrl}/pip-coord-details`, {
      withCredentials: true, //   ensures cookies are sent
    });
    return response.data;
  } catch (err) {
    console.error("Profile details:", err);
    throw err;
  }
}


//Bank Form Submit

export const submitBankDetails = async (bankDetails) => {
  try {
    const response = await axios.post(
      `${BaseUrl}/add-bank-details`, // URL
      bankDetails,                  // body data
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,      // ensures cookies/session are sent
      }
    );

    return response.data;
  } catch (err) {
    console.error("Bank details error:", err);
    throw err;
  }
};

//Fetch Bank Details\
export const fetchBankDetails = async () => {
  try {
    const response = await axios.get(
      `${BaseUrl}/get-bank-details`, {
      withCredentials: true, //   ensures cookies are sent
    });
    return response.data;
  } catch (err) {
    console.error("Bank details error:", err);
    throw err;
  }
};


//Fetch PIP Transaction  Details\
export const fetchTransDetails = async () => {
  try {
    const response = await axios.get(
      `${BaseUrl}/get-trans-details`, {
      withCredentials: true, //   ensures cookies are sent
    });
    return response.data;
  } catch (err) {
    console.error("Bank details error:", err);
    throw err;
  }
};


//Fetch Transaction  History\
export const fetchTransHistory = async () => {
  try {
    const response = await axios.get(
      `${BaseUrl}/get-trans-history`, {
      withCredentials: true, //   ensures cookies are sent
    });
    return response.data;
  } catch (err) {
    console.error("Bank details error:", err);
    throw err;
  }
};


//Group Registration
export const groupRegister = async (formData) => {
  try {
    const response = await axios.post(
      `${BaseUrl}/group-reg`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data", // optional, can be removed
        },
        withCredentials: true, //   ensures cookies/session are sent
      }
    );

    return response.data;
  } catch (err) {
    console.error("Group Register error:", err);
    throw err;
  }
};



//Fetch Group Registration Lists
export const fetchGroupRegList = async (trans_id) => {

  try {
    const response = await axios.get(
      `${BaseUrl}/get-group-list/${trans_id}`, {
      withCredentials: true, //   ensures cookies are sent
    });
    return response.data;
  } catch (err) {
    console.error("Group Register error:", err);
    throw err;
  }
};

//Access Course
export const accessCourse = async (courseId) => {
  try {
    const response = await axios.get(
      `${BaseUrl}/get-moodle-access/${courseId}`, {
      withCredentials: true, //   ensures cookies are sent
    });
    return response.data;
  } catch (err) {
    console.error("Course Access error:", err);
    throw err;
  }
};

// export const accessCourse = async (courseId) => {
//   try {
//     const response = await axios.get(
//       `${BaseUrl}/access/${courseId}/`, {
//       withCredentials: true, //   ensures cookies are sent
//     });
//     return response.data;
//   } catch (err) {
//     console.error("Course Access error:", err);
//     throw err;
//   }
// };


// ------------------- Payment -----------------//


//Ind pre Pay
export const prePayment = async (courseIds) => {
  try {
    const response = await axios.post(
      `${BaseUrl}/pre-pay-process`, //   removed courseIds from URL
      { course_ids: courseIds },   //   send as body
      {
        withCredentials: true,     //   must be in config, not body
      }
    );
    return response.data;
  } catch (err) {
    console.error("PrePayment error:", err);
    throw err;
  }
};


//Pip pre Pay
export const pipPrePayment = async (transactionId) => {
  try {
    const response = await axios.post(
      `${BaseUrl}/pre-pay-process`, //   removed courseIds from URL
      { transactionId },   //   send as body
      {
        withCredentials: true,     //   must be in config, not body
      }
    );
    return response.data;
  } catch (err) {
    console.error("PrePayment error:", err);
    throw err;
  }
};


////////////-----------Search Api ----------------///
export const courseSearch = async (keyWords) => {
  try {
    const response = await axios.get(
      `${BaseUrl}/search/${keyWords}`

    );
    return response.data;
  } catch (err) {
    console.error("PrePayment error:", err);
    throw err;
  }
};



//////------------ Report Api ----------//////////
export const reportSearch = async (id) => {
  console.log('Stu ID',id);
  try {
    // console.log(id);
    const response = await axios.post(
      `${BaseUrl}/report`,
      { stu_id: id },

    );
    return response.data;
  } catch (err) {
    console.error("PrePayment error:", err);
    throw err;
  }
};



/////////--------------------Password Reset token verify --------------------------/////
export const accessReset = async (id) => {
  try {
    const response = await axios.get(
      `${BaseUrl}/reset-token-verify/${id}`,
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      return err.response.data;
    } else {
      throw err;
    }
  }
};
/////////--------------------Password Reset  --------------------------/////
export const resetPassword = async (data) => {
  try {
    const response = await axios.post(
      `${BaseUrl}/reset-password`, data
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      return err.response.data;
    } else {
      throw err;
    }
  }
};




//////////////-----------Course Completion---------------//////
export const courseCompletion = async () => {
  try {
    const response = await axios.get(
      `${BaseUrl}/course-completion`,
      {
        withCredentials: true,     //   must be in config, not body
      }
    );
    return response.data;
  } catch (err) {
    console.error("course Completion error:", err);
    throw err;
  }
};



// Get All Users
export const getAllUsers = async () => {
  try {
    const response = await axios.get(
      `${BaseUrl}/all-registered-users`,
      {
        withCredentials: true,     //   must be in config, not body
      }
    );
    return response.data;
  } catch (err) {
    console.error("course Completion error:", err);
    throw err;
  }
};
// Get Course Category
export const getAllCourseCategory = async () => {
  try {
    const response = await axios.get(
      `${BaseUrl}/category`,
      {
        withCredentials: true,     //   must be in config, not body
      }
    );
    return response.data;
  } catch (err) {
    console.error("course Completion error:", err);
    throw err;
  }
};

//Set pricing  Details
export const setPricing = async (data) => {
  try {
    const response = await axios.post(`${BaseUrl}/set-pricing`, data, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    return response.data; // ✅ return only the data portion
  } catch (err) {
    console.error("Set Pricing API error:", err.response?.data || err.message);
    throw err; // ✅ rethrow so the component's catch block can handle it
  }
};
